<template lang="pug">
  div
    slot( v-bind:productInfo="productInfo" )
</template>

<script>
  export default {
    name: 'NutritionFacts',
    props: {
      gmProductId: {
        type: String,
        required: true,
      }
    },
    data() {
      return {
        productInfo: null
      };
    },
    mounted() {
      // Fetch product info (ingredients, nutritions)
      if (this.gmProductId) {
        fetch(`https://apigeex2.juicyorange.com/${window.profileSiteKey}/product/${this.gmProductId}`)
          .then(response => response.json())
          .then(data => {
            this.productInfo = data;
          });
      }
    }
  };
</script>

